import { WebApi } from '~/helpers/api/WebApi'
// @ts-ignore / TODO - rethink the eslint rule
export default ({ app }, inject) => {
  const instancedWebApi = new WebApi(app.$config.API_URL)
  inject('webApi', instancedWebApi)
}
